module.exports = __webpack_public_path__ + "img/svea_christiansen_8.2ba7693f.jpg";